import React from 'react';
import { IconButton, Typography, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    padding: '5px',
    borderRadius: '4px',
    color: '#315CD5'
  },
  icon: {
    marginRight: '0.3rem',
    width: '1.2rem !important',
    height: '1.2rem !important',
  },
});

const BackButton = ({ text, onGoBack }) => {
  const classes = useStyles();

  return (
    <IconButton
      color="inherit"
      className={classes.root}
      onClick={onGoBack}
    >
      <ArrowBack className={classes.icon} />
      <Typography variant="body1">
        {text}
      </Typography>
    </IconButton>
  );
};

export default BackButton;
